import { ListItem, ListItemText, IconButton } from "@mui/material"
import { InsertDriveFile, Close } from "@mui/icons-material"
import prettyBytes from "pretty-bytes"
import PropTypes from "prop-types"

export default function FileItem({ file, divider, removeFile, disabled = false }) {
  const handleRemoveFile = () => {
    removeFile(file)
  }

  return <ListItem
    divider={divider}
    secondaryAction={<IconButton onClick={handleRemoveFile} size="large" disabled={disabled} data-testid="upload-file-remove">
      <Close />
    </IconButton>}
  >
    <InsertDriveFile />
    <ListItemText primary={file.file.name} secondary={prettyBytes(file.file.size)} />
  </ListItem>
}

FileItem.propTypes = {
  removeFile: PropTypes.func.isRequired,
  file: PropTypes.object.isRequired,
  divider: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
}
